import Delegate from "ftdomdelegate";
import { qs, qsa } from "@fluorescent/dom";

import menuNav from "@/lib/mobile-menu-nav";
import { section } from "@/glow";
import { on } from "@/glow/events";
import AccountLogin from "@/lib/account/login";
import { activateTemplate } from "@/lib/templates";

const selectors = {
  mobileMenu: "[data-mobile-menu]",
  closeButton: ".mobile-menu-close-button",
  regionalForm: ".mobile-menu-regional-settings-form",
  regionalFormSelects: ".mobile-menu-regional-settings-form select",
  regionalFormSubmit: ".mobile-menu-regional-settings-form button",
  regionalFormCancel: ".regional-settings-cancel",
  accountControlsWrap: "[data-account-login]",
};

section("mobile-menu", {
  onLoad() {
    if (window.Shopify.designMode) {
      // In the theme editor we want the templates activated up front
      this.activateTemplateAndInitSubViews();
    }

    this.events = [
      on("mobile-menu:open", () => this.open()),
      on("mobile-menu:close", () => this.close()),
    ];

    this.delegate = new Delegate(this.container);
    this.delegate.on("click", selectors.closeButton, () => {
      this.close();
    });

    this.delegate.on("change", selectors.regionalFormSelects, () => {
      qs(selectors.regionalFormSubmit, this.container).removeAttribute(
        "disabled"
      );
    });

    this.delegate.on("click", selectors.regionalFormCancel, () => {
      const selects = qsa(selectors.regionalFormSelects, this.container);

      qs(selectors.regionalFormSubmit, this.container).setAttribute(
        "disabled",
        true
      );

      selects.forEach(select => {
        select.value = select.dataset.originalValue;
      });
    });
  },

  async open() {
    await this.activateTemplateAndInitSubViews();
    this.menuNav.open();
  },

  close() {
    this.menuNav.close();
  },

  onSelect() {
    this.open();
  },

  async onBlockSelect({ target }) {
    await this.open();
    const containingPane = target.closest("[data-pane-key]");
    const containingPaneKey = containingPane.getAttribute("data-pane-key");
    this.menuNav.navigateToPaneByKey(containingPaneKey);
  },

  onDeselect() {
    this.close();
  },

  onUnload() {
    this.delegate.off();
    this.events.forEach(unsubscribe => unsubscribe());
    this.accountLogin?.unload();
  },

  intitializeSubViewsIfNeeded() {
    if (!this.subViewsInitialized) {
      this.menuNav = menuNav(qs(selectors.mobileMenu));

      const accountLoginView = qs(
        selectors.accountControlsWrap,
        this.container
      );

      if (accountLoginView) {
        this.accountLogin = AccountLogin(accountLoginView);
      }

      this.subViewsInitialized = true;
    }
  },

  activateTemplateAndInitSubViews() {
    if (this.templateActivated) {
      if (!this.subViewsInitialized) {
        this.intitializeSubViewsIfNeeded();
      }

      return Promise.resolve(this);
    }

    if (this.pendingActivationPromise) {
      return this.pendingActivationPromise;
    }

    this.pendingActivationPromise = new Promise(resolve => {
      activateTemplate("mobile-menu-contents").then(result => {
        if (result.wasInjected) {
          if (!this.subViewsInitialized) {
            this.intitializeSubViewsIfNeeded();
          }

          this.templateActivated = true;
        }

        resolve(this);
        this.pendingActivationPromise = null;
      });
    });

    return this.pendingActivationPromise;
  },
});
